import questions from '../data/questions';
import { ActionTypes, IAppState, IUserFormInput } from '../types';
import getFinalScore from '../utils/getFinalScore';
import getNoneScoredAnswers from '../utils/getNonScoredAnswers';

export const initialAppState: IAppState = {
  activeCard: 0,
  totalCards: questions.length,
  userFormInput: {},
  helpedByBus: false,
  score: 0,
  finalized: false,
  submitted: false,
};

export type AppDispatch = React.Dispatch<{
  type: ActionTypes;
  payload?: IUserFormInput;
}>;

export const appReducer = (
  state: IAppState = initialAppState,
  action: {
    type: ActionTypes;
    payload?: IUserFormInput;
  },
): IAppState => {
  const { helpedByBuS } = getNoneScoredAnswers(state.userFormInput);
  switch (action.type) {
    case 'increment':
      if (state.activeCard < state.totalCards) {
        return {
          ...state,
          activeCard: state.activeCard + 1,
        };
      }
      throw new Error('Error: Can not increment beyond total number of cards');

    case 'decrement':
      if (state.activeCard > 0) {
        return {
          ...state,
          activeCard: state.activeCard - 1,
        };
      }
      throw new Error('Error: Can not decrement below zero');

    case 'finalize':
      if (Object.keys(state.userFormInput).length === 0)
        throw new Error('Error: Not all answers provided');
      return {
        ...state,
        score: getFinalScore(state.userFormInput),
        helpedByBus: helpedByBuS,
        finalized: true,
      };

    case 'setAnswers':
      if (typeof action.payload !== 'undefined')
        return { ...state, userFormInput: action.payload };
      throw new Error('Error: Missing payload, unable to set score');

    default:
      throw new Error('Invalid action passed to reducer');
  }
};
